import 'regenerator-runtime/runtime'
import 'core-js/stable'

import { init } from '@danone-global/internal/react/core'

import { environment as config, features, theme, widgets } from './config'

init({ config, theme, features, widgets })
